import type { ProductSecondaryIdentifier } from '@xbcb/api-gateway-client';
import { transformLines } from './workOrder/usConsumptionEntry';

/**
 * Strip anything that might be added by rule engine evaluation
 * and associated logic (which all write to form state so can end up here)
 * to match Product input.
 */

const stripEvaluatedTariffFields = (lines?: any[]): void => {
  lines?.forEach((line) => {
    delete line.cbpCharges;
    delete line.candidateAdditionalTariffs;
    line.tariffs?.forEach((tariff: any) => {
      delete tariff.tariffType;
      delete tariff.charges;
    });
  });
};

export const transformProduct = {
  toForm: ({ existingRecord: newRecord }: { existingRecord: any }) => {
    transformLines.toForm({
      lines: newRecord.complianceDetails?.us?.entryLines,
    });
    return newRecord;
  },

  toCreateSchema: ({ input }: { input: any }) => {
    input.secondaryIdentifiers = input.secondaryIdentifiers?.filter(
      (si: ProductSecondaryIdentifier) => si.value,
    );
    transformLines.toSchema({ lines: input.complianceDetails?.us?.entryLines });
    stripEvaluatedTariffFields(input.complianceDetails?.us?.entryLines);
    return input;
  },

  toUpdateSchema: ({ input }: { input: any }) => {
    input.secondaryIdentifiers = input.secondaryIdentifiers?.filter(
      (si: ProductSecondaryIdentifier) => si.value,
    );
    transformLines.toSchema({ lines: input.complianceDetails?.us?.entryLines });
    stripEvaluatedTariffFields(input.complianceDetails?.us?.entryLines);
    delete input.shipper;
    return input;
  },
};
